/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import type { TypeActe } from '@/types';

/**
 * Quels types d'acte sont réellement livrés, et lesquels sont seulement
 * déclarés dans l'union `TypeActe`.
 *
 * ⚠️ Volontairement typé `Record<TypeActe, boolean>` **complet** (et non
 * `Partial`) : ajouter un membre à l'union `TypeActe` sans le déclarer ici
 * devient une erreur de compilation. C'est le seul endroit du projet où
 * l'exhaustivité des types d'acte est vérifiée par le compilateur.
 */
const TYPES_ACTES_CONNUS: Record<TypeActe, boolean> = {
  naissance: true,
  reconnaissance: true,
  mariage: true,
  deces: true,
  pacs: false,
  decision: false,
};

/**
 * Types d'acte dont le parcours de numérisation est livré de bout en bout.
 *
 * ⚠️ Passer une valeur à `true` ci-dessus ne suffit pas : le parcours est
 * éclaté en sept registres indexés par `TypeActe`, aucun vérifié par le
 * compilateur, et trois échouent **silencieusement** quand une entrée manque
 * (assistant sans étape, arbre des registres non filtré, libellé par défaut de
 * la lib).
 *
 * Rien à retenir de cette liste : `src/__tests__/typesActesImplementes.tsx` la
 * transforme en checklist exécutable et nomme le registre à remplir.
 */
export const TYPES_ACTES_IMPLEMENTES = (
  Object.keys(TYPES_ACTES_CONNUS) as TypeActe[]
).filter((typeActe) => TYPES_ACTES_CONNUS[typeActe]);

/**
 * Types d'acte déclarés dans l'union mais dont le parcours n'existe pas encore.
 * Aucun registre ne doit les référencer : une entrée présente ici *et* dans un
 * registre signifie que `TYPES_ACTES_CONNUS` est périmé.
 */
export const TYPES_ACTES_NON_IMPLEMENTES = (
  Object.keys(TYPES_ACTES_CONNUS) as TypeActe[]
).filter((typeActe) => !TYPES_ACTES_CONNUS[typeActe]);

export default TYPES_ACTES_CONNUS;
